/**
 * Stash Tea Footer Accordion Functionality & Instagram Feed Detection
 */

document.addEventListener('DOMContentLoaded', function () {
	// Accordion functionality
	const accordionToggles = document.querySelectorAll('[data-accordion-toggle]');
	const successMessage = document.querySelector('.newsletter-success');
	const emailInput = document.querySelector('.newsletter-input');
	const joinButton = document.querySelector('.join-button');
	const duration = 5000;

	accordionToggles.forEach(function (button) {
		button.addEventListener('click', function (e) {
			e.preventDefault();

			const item = this.parentElement;
			const wasActive = item.classList.contains('active');

			// Close all accordion items
			document.querySelectorAll('.accordion-item').forEach(function (accordionItem) {
				accordionItem.classList.remove('active');
			});

			// Open clicked item if it wasn't active
			if (!wasActive) {
				item.classList.add('active');
			}
		});
	});

	// Instagram Feed Widget Detection
	function checkInstagramWidget() {
		const desktopContainer = document.getElementById('instafeed-container');
		const mobileContainer = document.getElementById('instafeed-container-mobile');

		// Check for common Instagram widget selectors
		// Adjust these selectors based on the actual GSC Instagram Feed widget structure
		const widgetSelectors = [
			'.instagram-feed',
			'.sb-instagram-feed',
			'.elfsight-app-instagram-feed',
			'[data-instagram-feed]',
			'#sb_instagram'
		];

		function hasActiveWidget(container) {
			if (!container) return false;

			for (let selector of widgetSelectors) {
				if (container.querySelector(selector)) {
					return true;
				}
			}

			// Also check if container has children besides the placeholder
			const children = Array.from(container.children);
			return children.some(child => !child.classList.contains('instagram-feed-placeholder'));
		}

		// Mark containers as active if widget is detected
		if (desktopContainer && hasActiveWidget(desktopContainer)) {
			desktopContainer.classList.add('widget-active');
		}

		if (mobileContainer && hasActiveWidget(mobileContainer)) {
			mobileContainer.classList.add('widget-active');
		}
	}

	// Check immediately
	checkInstagramWidget();

	// Check again after a delay (in case widget loads slowly)
	setTimeout(checkInstagramWidget, 1000);
	setTimeout(checkInstagramWidget, 3000);

	// Use MutationObserver to detect when Instagram widget is injected
	const desktopContainer = document.getElementById('instafeed-container');
	const mobileContainer = document.getElementById('instafeed-container-mobile');

	if (desktopContainer) {
		const observer = new MutationObserver(function () {
			checkInstagramWidget();
		});

		observer.observe(desktopContainer, {
			childList: true,
			subtree: true
		});
	}

	if (mobileContainer) {
		const observer = new MutationObserver(function () {
			checkInstagramWidget();
		});

		observer.observe(mobileContainer, {
			childList: true,
			subtree: true
		});
	}

	if (successMessage) {

		if (emailInput) {
			emailInput.style.display = 'none';
		}
		if (joinButton) {
			joinButton.style.display = 'none';
		}

		successMessage.style.display = 'block';

		setTimeout(function () {
			if (emailInput) {
				emailInput.style.display = 'revert';
			}
			if (joinButton) {
				joinButton.style.display = 'revert';
			}

			successMessage.style.display = 'none';

		}, duration);
	}
});
